// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__16yjO","image2":"Card_image2__M_AaQ","text":"Card_text__3pSMy"};